function getAge(liga, nacimiento) {
    if (!liga || !nacimiento) return "-";
    const yearMatch = String(liga).match(/(\d{4})/);
    const birthYear = new Date(nacimiento).getFullYear();

    if (!yearMatch || Number.isNaN(birthYear)) return "-";
    return Number(yearMatch[1]) - birthYear;
}

function formatValue(value, decimals = 2) {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue.toFixed(decimals) : "0.00";
}

function getValue(item, keys, fallback = 0) {
    if (!item) return fallback;
    const keyList = Array.isArray(keys) ? keys : [keys];
    const foundKey = keyList.find((key) => item[key] !== undefined && item[key] !== null);
    return foundKey ? item[foundKey] : fallback;
}

function formatPercent(value) {
    if (value === undefined || value === null || value === "") return "0%";
    const stringValue = String(value);
    return stringValue.includes("%") ? stringValue : `${stringValue}%`;
}

function buildPercent(made, attempted, percent) {
    if (percent !== undefined && percent !== null && percent !== "") return formatPercent(percent);
    const madeValue = Number(made);
    const attemptedValue = Number(attempted);
    if (!Number.isFinite(madeValue) || !Number.isFinite(attemptedValue) || attemptedValue === 0) return "0%";
    return `${((madeValue / attemptedValue) * 100).toFixed(1)}%`;
}

function isInternationalLeague(item) {
    if (!item) return false;

    const liga = String(item.liga || "").toUpperCase();
    return !liga.includes("LUB");
}

function getLeagueKey(liga) {
    return String(liga || "").trim().toUpperCase();
}

function TableColumnsHeader({ sectionTitle }) {
    return (
        <tr className="bg-[#102216] text-xs md:text-sm uppercase tracking-wider text-slate-500 border-y border-white/10">
            <th className="px-4 py-2.5 text-left">{sectionTitle}</th>
            <th className="px-2 py-2.5 text-center">Edad</th>
            <th className="px-2 py-2.5 text-center">Partidos</th>
            <th className="px-2 py-2.5 text-center">Ganados</th>
            <th className="px-2 py-2.5 text-center">Perdidos</th>
            <th className="px-2 py-2.5 text-center">Gan %</th>
            <th className="px-2 py-2.5 text-center">Min</th>
            <th className="px-2 py-2.5 text-center">Pts</th>
            <th className="px-2 py-2.5 text-center">RO</th>
            <th className="px-2 py-2.5 text-center">RD</th>
            <th className="px-2 py-2.5 text-center">RT</th>
            <th className="px-2 py-2.5 text-center">AS</th>
            <th className="px-2 py-2.5 text-center">TC H</th>
            <th className="px-2 py-2.5 text-center">TC L</th>
            <th className="px-2 py-2.5 text-center">TC%</th>
            <th className="px-2 py-2.5 text-center">2PTS H</th>
            <th className="px-2 py-2.5 text-center">2PTS L</th>
            <th className="px-2 py-2.5 text-center">2PTS%</th>
            <th className="px-2 py-2.5 text-center">3PTS H</th>
            <th className="px-2 py-2.5 text-center">3PTS L</th>
            <th className="px-2 py-2.5 text-center">3PTS%</th>
            <th className="px-2 py-2.5 text-center">1PTS H</th>
            <th className="px-2 py-2.5 text-center">1PTS L</th>
            <th className="px-2 py-2.5 text-center">1PTS%</th>
            <th className="px-2 py-2.5 text-center">PER</th>
            <th className="px-2 py-2.5 text-center">ROB</th>
            <th className="px-2 py-2.5 text-center">BLQ</th>
            <th className="px-2 py-2.5 text-center">FP</th>
        </tr>
    );
}

function AverageRow({ item, totalsByLeague, nacimiento, onLeagueClick }) {
    const totalsItem = totalsByLeague.get(getLeagueKey(item.liga)) || null;

    return (
        <tr key={`prom-${item.liga}`} className="hover:bg-white/5 transition-colors">
            <td className="px-4 py-2.5 font-medium text-green-400">
                <button
                    type="button"
                    onClick={() => onLeagueClick?.(item.liga)}
                    className="hover:underline"
                >
                    {item.liga}
                </button>
            </td>
            <td className="px-2 py-2.5 text-center">{getAge(item.liga, nacimiento)}</td>
            <td className="px-2 py-2.5 text-center">{getValue(totalsItem, ["partidos", "pj"])} </td>
            <td className="px-2 py-2.5 text-center">{getValue(totalsItem, ["ganados", "pg"])} </td>
            <td className="px-2 py-2.5 text-center">{getValue(totalsItem, ["perdidos", "pp"])} </td>
            <td className="px-2 py-2.5 text-center">{formatPercent(getValue(totalsItem, ["winPerc", "winPercentage"], "0%"))}</td>
            <td className="px-2 py-2.5 text-center">{formatValue(getValue(item, ["mpg"]))}</td>
            <td className="px-2 py-2.5 text-center">{formatValue(getValue(item, ["ppg"]))}</td>
            <td className="px-2 py-2.5 text-center">{formatValue(getValue(item, ["ropg", "orpg", "rop"]))}</td>
            <td className="px-2 py-2.5 text-center">{formatValue(getValue(item, ["rdpg", "drpg", "rdp"]))}</td>
            <td className="px-2 py-2.5 text-center">{formatValue(getValue(item, ["rtpg", "trpg"]))}</td>
            <td className="px-2 py-2.5 text-center">{formatValue(getValue(item, ["apg", "astpg"]))}</td>
            <td className="px-2 py-2.5 text-center">{formatValue(getValue(item, ["tchpg", "camposHechosPg"]))}</td>
            <td className="px-2 py-2.5 text-center">{formatValue(getValue(item, ["tclpg", "camposIntentPg"]))}</td>
            <td className="px-2 py-2.5 text-center">{buildPercent(getValue(item, ["tchpg", "camposHechosPg"]), getValue(item, ["tclpg", "camposIntentPg"]), getValue(item, ["tcperc", "camposPercent"]))}</td>
            <td className="px-2 py-2.5 text-center">{formatValue(getValue(item, ["tdhpg", "doblesHechosPg"]))}</td>
            <td className="px-2 py-2.5 text-center">{formatValue(getValue(item, ["tdlpg", "doblesIntentPg"]))}</td>
            <td className="px-2 py-2.5 text-center">{buildPercent(getValue(item, ["tdhpg", "doblesHechosPg"]), getValue(item, ["tdlpg", "doblesIntentPg"]), getValue(item, ["tdperc", "doblesPercent"]))}</td>
            <td className="px-2 py-2.5 text-center">{formatValue(getValue(item, ["tthpg", "triplesHechosPg"]))}</td>
            <td className="px-2 py-2.5 text-center">{formatValue(getValue(item, ["ttlpg", "triplesIntentPg"]))}</td>
            <td className="px-2 py-2.5 text-center">{buildPercent(getValue(item, ["tthpg", "triplesHechosPg"]), getValue(item, ["ttlpg", "triplesIntentPg"]), getValue(item, ["ttperc", "triplesPercent"]))}</td>
            <td className="px-2 py-2.5 text-center">{formatValue(getValue(item, ["tlhpg", "libresHechosPg"]))}</td>
            <td className="px-2 py-2.5 text-center">{formatValue(getValue(item, ["tllpg", "libresIntentPg"]))}</td>
            <td className="px-2 py-2.5 text-center">{buildPercent(getValue(item, ["tlhpg", "libresHechosPg"]), getValue(item, ["tllpg", "libresIntentPg"]), getValue(item, ["tlperc", "libresPercent"]))}</td>
            <td className="px-2 py-2.5 text-center">{formatValue(getValue(item, ["topg"]))}</td>
            <td className="px-2 py-2.5 text-center">{formatValue(getValue(item, ["spg"]))}</td>
            <td className="px-2 py-2.5 text-center">{formatValue(getValue(item, ["bpg"]))}</td>
            <td className="px-2 py-2.5 text-center">{formatValue(getValue(item, ["fpg"]))}</td>
        </tr>
    );
}

export default function JugadorAveragesTable({
    averages = [],
    totals = [],
    careerProm,
    careerTotals,
    nacimiento,
    onLeagueClick,
    isCollapsed = false,
    onToggleCollapse,
}) {
    if (!averages.length) {
        return null;
    }

    const localAverages = averages.filter((item) => !isInternationalLeague(item));
    const internationalAverages = averages.filter((item) => isInternationalLeague(item));
    const localLeaguesCount = localAverages.length;
    const internationalLeaguesCount = internationalAverages.length;
    const totalsByLeague = new Map(totals.map((item) => [getLeagueKey(item.liga), item]));

    return (
        <section className="mb-12">
            <div className={`flex items-center justify-between gap-3 border border-white/10 bg-[#102216] px-4 py-1.5 ${isCollapsed ? "rounded-lg" : "rounded-t-lg"}`}>
                <h3 className="text-base md:text-lg font-bold text-slate-200">Promedios</h3>
                <button
                    type="button"
                    onClick={onToggleCollapse}
                    className="text-xs font-semibold uppercase tracking-wide text-slate-300 transition-colors hover:text-green-400"
                >
                    {isCollapsed ? "Mostrar" : "Ocultar"}
                </button>
            </div>
            <div className={`grid transition-[grid-template-rows,opacity] duration-300 ease-out ${isCollapsed ? "grid-rows-[0fr] opacity-0" : "grid-rows-[1fr] opacity-100"}`}>
                <div className="min-h-0 overflow-hidden">
                    <div className="-mt-px overflow-x-auto rounded-b-xl border-x border-b border-white/10 bg-[#102216] relative">
                        <p className="sm:hidden text-[10px] text-slate-500 text-right px-3 py-1 sticky top-0 left-0 z-20 w-fit ml-auto pointer-events-none">Desliza para ver más →</p>
                        <table className="table-auto w-max min-w-full text-left text-xs sm:text-sm">
                    <thead>
                        <tr className="bg-[#102216] text-xs md:text-sm font-bold uppercase tracking-wider text-slate-500 border-b border-white/10">
                            <th className="px-4 py-3">Liga ({localLeaguesCount})</th>
                            <th className="px-2 py-3 text-center">Edad</th>
                            <th className="px-2 py-3 text-center">Partidos</th>
                            <th className="px-2 py-3 text-center">Ganados</th>
                            <th className="px-2 py-3 text-center">Perdidos</th>
                            <th className="px-2 py-3 text-center">Gan %</th>
                            <th className="px-2 py-3 text-center">Min</th>
                            <th className="px-2 py-3 text-center">Pts</th>
                            <th className="px-2 py-3 text-center">RO</th>
                            <th className="px-2 py-3 text-center">RD</th>
                            <th className="px-2 py-3 text-center">RT</th>
                            <th className="px-2 py-3 text-center">AS</th>
                            <th className="px-2 py-3 text-center">TC H</th>
                            <th className="px-2 py-3 text-center">TC L</th>
                            <th className="px-2 py-3 text-center">TC%</th>
                            <th className="px-2 py-3 text-center">2PTS H</th>
                            <th className="px-2 py-3 text-center">2PTS L</th>
                            <th className="px-2 py-3 text-center">2PTS%</th>
                            <th className="px-2 py-3 text-center">3PTS H</th>
                            <th className="px-2 py-3 text-center">3PTS L</th>
                            <th className="px-2 py-3 text-center">3PTS%</th>
                            <th className="px-2 py-3 text-center">1PTS H</th>
                            <th className="px-2 py-3 text-center">1PTS L</th>
                            <th className="px-2 py-3 text-center">1PTS%</th>
                            <th className="px-2 py-3 text-center">PER</th>
                            <th className="px-2 py-3 text-center">ROB</th>
                            <th className="px-2 py-3 text-center">BLQ</th>
                            <th className="px-2 py-3 text-center">FP</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-white/10 text-slate-300">
                        {localAverages.map((item) => (
                            <AverageRow key={`prom-local-${item.liga}`} item={item} totalsByLeague={totalsByLeague} nacimiento={nacimiento} onLeagueClick={onLeagueClick} />
                        ))}

                        {internationalAverages.length > 0 && localAverages.length > 0 ? (
                            <TableColumnsHeader sectionTitle={`Internacional (${internationalLeaguesCount})`} />
                        ) : null}

                        {internationalAverages.map((item) => (
                            <AverageRow key={`prom-int-${item.liga}`} item={item} totalsByLeague={totalsByLeague} nacimiento={nacimiento} onLeagueClick={onLeagueClick} />
                        ))}

                        {careerProm ? (
                            <tr className="bg-green-500/10 text-slate-100 border-t border-green-400/30">
                                <td className="px-4 py-3 uppercase">Carrera</td>
                                <td className="px-2 py-3 text-center">-</td>
                                <td className="px-2 py-3 text-center">{careerTotals?.partidos ?? 0}</td>
                                <td className="px-2 py-3 text-center">{careerTotals?.ganados ?? 0}</td>
                                <td className="px-2 py-3 text-center">{careerTotals?.perdidos ?? 0}</td>
                                <td className="px-2 py-3 text-center">{formatPercent(careerTotals?.winPerc)}</td>
                                <td className="px-2 py-3 text-center">{formatValue(getValue(careerProm, ["mpg"]))}</td>
                                <td className="px-2 py-3 text-center">{formatValue(getValue(careerProm, ["ppg"]))}</td>
                                <td className="px-2 py-3 text-center">{formatValue(getValue(careerProm, ["ropg", "orpg", "rop"]))}</td>
                                <td className="px-2 py-3 text-center">{formatValue(getValue(careerProm, ["rdpg", "drpg", "rdp"]))}</td>
                                <td className="px-2 py-3 text-center">{formatValue(getValue(careerProm, ["rtpg", "trpg"]))}</td>
                                <td className="px-2 py-3 text-center">{formatValue(getValue(careerProm, ["apg", "astpg"]))}</td>
                                <td className="px-2 py-3 text-center">{formatValue(getValue(careerProm, ["tchpg", "camposHechosPg"]))}</td>
                                <td className="px-2 py-3 text-center">{formatValue(getValue(careerProm, ["tclpg", "camposIntentPg"]))}</td>
                                <td className="px-2 py-3 text-center">{buildPercent(getValue(careerProm, ["tchpg", "camposHechosPg"]), getValue(careerProm, ["tclpg", "camposIntentPg"]), getValue(careerProm, ["tcperc", "camposPercent"]))}</td>
                                <td className="px-2 py-3 text-center">{formatValue(getValue(careerProm, ["tdhpg", "doblesHechosPg"]))}</td>
                                <td className="px-2 py-3 text-center">{formatValue(getValue(careerProm, ["tdlpg", "doblesIntentPg"]))}</td>
                                <td className="px-2 py-3 text-center">{buildPercent(getValue(careerProm, ["tdhpg", "doblesHechosPg"]), getValue(careerProm, ["tdlpg", "doblesIntentPg"]), getValue(careerProm, ["tdperc", "doblesPercent"]))}</td>
                                <td className="px-2 py-3 text-center">{formatValue(getValue(careerProm, ["tthpg", "triplesHechosPg"]))}</td>
                                <td className="px-2 py-3 text-center">{formatValue(getValue(careerProm, ["ttlpg", "triplesIntentPg"]))}</td>
                                <td className="px-2 py-3 text-center">{buildPercent(getValue(careerProm, ["tthpg", "triplesHechosPg"]), getValue(careerProm, ["ttlpg", "triplesIntentPg"]), getValue(careerProm, ["ttperc", "triplesPercent"]))}</td>
                                <td className="px-2 py-3 text-center">{formatValue(getValue(careerProm, ["tlhpg", "libresHechosPg"]))}</td>
                                <td className="px-2 py-3 text-center">{formatValue(getValue(careerProm, ["tllpg", "libresIntentPg"]))}</td>
                                <td className="px-2 py-3 text-center">{buildPercent(getValue(careerProm, ["tlhpg", "libresHechosPg"]), getValue(careerProm, ["tllpg", "libresIntentPg"]), getValue(careerProm, ["tlperc", "libresPercent"]))}</td>
                                <td className="px-2 py-3 text-center">{formatValue(getValue(careerProm, ["topg"]))}</td>
                                <td className="px-2 py-3 text-center">{formatValue(getValue(careerProm, ["spg"]))}</td>
                                <td className="px-2 py-3 text-center">{formatValue(getValue(careerProm, ["bpg"]))}</td>
                                <td className="px-2 py-3 text-center">{formatValue(getValue(careerProm, ["fpg"]))}</td>
                            </tr>
                        ) : null}
                    </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    );
}
